import type { FolderSelectorProps } from './types';

export default function FolderSelector({
  folders,
  selectedFolders,
  onFoldersChange,
  onSelectionChange,
  onAddFolder,
  onRemoveFolder,
  isImporting = false,
  showAdvancedOptions = false,
  maxFolders,
}: FolderSelectorProps) {
  const handleAddFolder = () => {
    if (!isImporting && (!maxFolders || folders.length < maxFolders)) {
      onAddFolder();
    }
  };

  const isMaxFoldersReached = Boolean(
    maxFolders && folders.length >= maxFolders,
  );

  return (
    <div className="folder-selector">
      <div className="folder-selector__header">
        {/* Old long Add Folder button removed; toolbar button is used instead */}

        {isMaxFoldersReached && (
          <div className="folder-selector__limit-notice">
            Maximum of {maxFolders} folders allowed
          </div>
        )}
      </div>
    </div>
  );
}
